<template>
	<template v-if="visible">
		<template v-for="(widget, idx) in widgets" :key="idx">
			<widget-part :data="localData" :part="widget" :readonly="ro" :viewmode="vm"></widget-part>
		</template>
	</template>
</template>

<script setup lang="ts">
import {computed, defineProps} from "vue";
import useContainer, {type ContainerProps, containerProps} from "./Container";
import {DataWidgets} from "@t/fd/layout/Widgets.ts";
import type {Widget} from "@t/fd/layout/Widget.ts";
import WidgetPart from "@fd/containers/WidgetPart.vue";
import {getter} from "@fd/Part.ts";

const uprops = defineProps({
	...containerProps,
});
const props = uprops as ContainerProps;
const dw = computed<DataWidgets>(() => props.part as DataWidgets);

const {localData, ro, vm, visible, formData} = useContainer(props);

const widgets = computed<Widget[]>(() => {
	const warray = getter(props.data as FormData, dw.value.editors, formData); // should point to property with array (may be undefined)
	if (Array.isArray(warray)) return warray;
	return [];
});
</script>

<style>

</style>